
namespace TabAurous.ProductDevelopment {

    @Serenity.Decorators.registerClass()
    export class SpecSheetBOMGrid extends Serenity.EntityGrid<SpecSheetBOMRow, any> {
        protected getColumnsKey() { return 'ProductDevelopment.SpecSheetBOM'; }
        protected getDialogType() { return SpecSheetBOMDialog; }
        protected getIdProperty() { return SpecSheetBOMRow.idProperty; }
        protected getInsertPermission() { return SpecSheetBOMRow.insertPermission; }
        protected getLocalTextPrefix() { return SpecSheetBOMRow.localTextPrefix; }
        protected getService() { return SpecSheetBOMService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            this.slickGrid.setOptions({ rowHeight: 30 });
        }
    }
}